import { SelectOption } from '../models';

export enum ConnectingMethod {
  SNAIL = 'SNAIL',
  LINE = 'LINE',
}

export class ConnectingMethodHelper {
  private static readonly labelMap: Record<ConnectingMethod, string> = {
    [ConnectingMethod.SNAIL]: 'Snail',
    [ConnectingMethod.LINE]: 'Line',
  };

  static enumToLabelKey(connectingMethod: ConnectingMethod): string {
    return this.labelMap[connectingMethod] ?? '';
  }

  private static getConstantList(): ConnectingMethod[] {
    return [ConnectingMethod.LINE, ConnectingMethod.SNAIL];
  }

  static getOptions(): SelectOption[] {
    return this.getConstantList().map((connectingMethod) => ({
      label: this.enumToLabelKey(connectingMethod),
      value: connectingMethod,
    }));
  }
}
